<div class="global-ajax-loader" ng-show="showSpinner">
    <div class="global-ajax-loader-container" ng-style="size">
        <img src="styles/img/eVAYO-img/common/global-ajax-loader.gif"/>
    </div>
</div>
